import { createAction, props } from '@ngrx/store';

import { Taxonomy } from '@app/core/models/taxonomy.model';

export const departmentsNestedCollectionAddMany = createAction(
  '[STORED DEPARTMENTS NESTED - ADD MANY] Departments Nested collection add many.',
  props<{ departmentsNested: Taxonomy[] }>()
);
